var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0291 8.20703C21.7741 8.20703 15.0581 14.7738 15.0581 22.8454C15.0581 30.917 21.7741 37.4837 30.0291 37.4837C38.2842 37.4837 45.0002 30.917 45.0002 22.8454C45.0002 14.7738 38.2842 8.20703 30.0291 8.20703ZM30.0291 34.9056C23.228 34.9056 17.6948 29.4954 17.6948 22.8454C17.6948 16.1954 23.228 10.7852 30.0291 10.7852C36.8303 10.7852 42.3634 16.1954 42.3634 22.8454C42.3634 29.4954 36.8303 34.9056 30.0291 34.9056Z",
    fill: "#1996A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12744 14.1992H11.3645V16.7773H3.12744V14.1992Z",
    fill: "#1996A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12744 28.9141H11.3645V31.4922H3.12744V28.9141Z",
    fill: "#1996A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.5547H11.3643V24.1328H0V21.5547Z",
    fill: "#1996A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0292 18.6557C30.8468 18.6557 31.512 19.3061 31.512 20.1056H34.1487C34.1487 18.3354 32.9742 16.8293 31.3475 16.2904V14.1953H28.7108V16.2904C27.0842 16.8293 25.9097 18.3354 25.9097 20.1056C25.9097 22.3266 27.7577 24.1336 30.0292 24.1336C30.8468 24.1336 31.512 24.7839 31.512 25.5834C31.512 26.3829 30.8468 27.0333 30.0292 27.0333C29.2115 27.0333 28.5464 26.3829 28.5464 25.5834H25.9097C25.9097 27.3536 27.0842 28.8597 28.7108 29.3986V31.4937H31.3475V29.3986C32.9742 28.8597 34.1487 27.3536 34.1487 25.5834C34.1487 23.3624 32.3007 21.5554 30.0292 21.5554C29.2115 21.5554 28.5464 20.9051 28.5464 20.1056C28.5464 19.3061 29.2115 18.6557 30.0292 18.6557Z",
    fill: "#1996A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/Money.ecb187f870c353746aa925c4f21efc85.svg";
export { ForwardRef as ReactComponent };